import { defineStore } from "pinia";

export const useRecruitmentCvTechStore = defineStore('recruitmentCvTech', {
  state: () => ({
    recruitmentCvTech: {},
    recruitmentCvTechs: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setRecruitmentCvTech(recruitmentCvTech) {
      this.recruitmentCvTech = recruitmentCvTech
    },
    setRecruitmentCvTechs(recruitmentCvTechs) {
      this.recruitmentCvTechs = recruitmentCvTechs
    },
    addRecruitmentCvTech(recruitmentCvTech) {
      this.recruitmentCvTechs.unshift(recruitmentCvTech)
    },
    updateRecruitmentCvTech(recruitmentCvTech) {
      let index = this.recruitmentCvTechs.findIndex(cl => cl.id === recruitmentCvTech.id)
      this.recruitmentCvTechs.splice(index, 1, recruitmentCvTech)
    },
    deleteRecruitmentCvTech(recruitmentCvTech) {
      let index = this.recruitmentCvTechs.findIndex(cl => cl.id === recruitmentCvTech.id)
      this.recruitmentCvTechs.splice(index, 1)
    },
  },
});